import React from 'react'
import { observeImmutable } from '@core/Components/HOCs/observe'
import { NoticeBox } from '@core/Components/NoticeBox/NoticeBox'
import { state$ } from '../../driver'

export const NameDateOfBirthChangedNotice = observeImmutable(state$, ({ record }) => {
  return (
    <NameDateOfBirthChangedNoticeComponent nameDateOfBirthChanged={record.nameDateOfBirthChanged} />
  )
})

export function NameDateOfBirthChangedNoticeComponent({
  nameDateOfBirthChanged,
}: {
  nameDateOfBirthChanged: boolean
}) {
  if (nameDateOfBirthChanged) {
    return (
      <NoticeBox title='To allow us to contact you!' noticeBoxType='Warning' hasBorder>
        Please make sure your contact number is correct or update it before you select save.
      </NoticeBox>
    )
  }

  return null
}
